import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';

import { Bert } from 'meteor/themeteorchef:bert';
import { cloneDeep, map, isEmpty, isEqual, indexOf } from 'lodash';
import {
  Box,
  Button,
  Grid,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
  TextField,
  Alert
} from '@mui/material';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import Loading from '../Loading';

import AnnotationTemplatePreview from '../AnnotationTemplatePreview';
import AnnotationTemplates from '../../../api/AnnotationTemplates/AnnotationTemplates';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';
import * as videoOps from '../../../api/Videos/video-operations';
import * as videoCalculate from '../../../api/Videos/videos-calculations';
import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';
import useTimeStore from '../ZustandProvider';

import { importAnnotations } from '../../../api/Annotations/annotation-methods-client';

const ImportAnnotationMaps = props => {
  const {
    annotationsTemplate,
    handleCloseImport,
    loading,
    isPublicMap,
    fileJson,
    fileName,
    timeVideoDuration,
    sizePlayer,
    videoSelected,
    annotationsProp,
    methodImport
  } = props;

  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const setNotesVideoEditor = useTimeStore(state => state.setNotesVideoEditor);
  const proyectedPointTrackVideo = useTimeStore(state => state.proyectedPointTrackVideo);

  const isVideoLine = videoSelected.coordinatesDataType !== VIDEO_COORDINATE_DATA_TYPES.POINT;

  const [activeStep, setActiveStep] = React.useState(0);
  const [fieldsTemplate, setFieldsTemplate] = React.useState({});
  const [timeNewAnnotation, setTimeNewAnnotation] = React.useState(0);
  const [isValidateSchema, setValidateSchema] = React.useState('none');
  const [newCoords, setNewCoords] = React.useState(coordOnMap);
  const [newTemplateId, setNewTemplateId] = React.useState('');

  let countColumn = 1;
  let countRow = 1;
  const objectForTable = [];
  const steps =
    isValidateSchema === 'validate'
      ? ['Seleccionar método de importación']
      : ['Ubicación', 'Tiempo', 'Resumen'];

  const submitNewAnnotation = async annotation => {
    try {
      await methodPromise('annotations.insert', annotation, isPublicMap);
      Bert.alert('Annotation created', 'success');
      handleCloseImport();
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  const submitNewTemplate = async template => {
    try {
      const newId = await methodPromise('annotationTemplates.insert', template);
      setNewTemplateId(newId);
      Bert.alert('Template created', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const getValuesForTable = object => {
    let outValue = false;
    let stringElementArray = '';
    map(object, (element, key) => {
      if (typeof key === 'string') {
        if (typeof element === 'string' || typeof element === 'number' || Array.isArray(element)) {
          if (Array.isArray(element)) {
            map(element, checkIsObj => {
              if (typeof checkIsObj === 'object') {
                outValue = true;
              } else {
                for (let i = 0; i < element.length; i += 1) {
                  stringElementArray = stringElementArray.concat(`${element[i]}`);
                }
              }
            });
          }
          if (!outValue) {
            const stringElement = Array.isArray(element) ? stringElementArray : element;
            objectForTable.push({
              key,
              content: stringElement,
              row: countRow,
              column: countColumn
            });
            countColumn += 1;
          }
        }
      }
      if (typeof element !== 'string' && typeof element !== 'number') {
        if (!outValue) {
          countRow += 1;
          countColumn = 1;
          objectForTable.push({ key: '', content: '------', row: countRow, column: countColumn });
          countRow += 1;
        }
        getValuesForTable(element);
      }
      outValue = false;
    });
    return objectForTable;
  };

  const createElementsTemplate = (header, content, row, column) => {
    const elementsObject = {
      row,
      column,
      order: parseInt(`${row}${column}`, 10),
      elementKey: fileName,
      elementType: 'input',
      labelName: content === 'NoValue' ? '' : header,
      value: content === 'NoValue' ? header : content
    };
    return elementsObject;
  };

  const createTemplate = async () => {
    const elementsTemplate = [];
    const tagsProps = [];

    const valuesForTable = getValuesForTable(fileJson);
    map(valuesForTable, element => {
      const stringContent =
        typeof element.content === 'number' ? element.content.toString() : element.content;
      if (typeof stringContent === 'string' || Array.isArray(stringContent)) {
        const elementsTemplateObj = createElementsTemplate(
          element.key,
          stringContent,
          element.row,
          element.column
        );
        tagsProps.push({ id: 'importMaps', text: 'notesComponent' });
        elementsTemplate.push(elementsTemplateObj);
      }
    });

    const templateSave = {
      name: fileName,
      icon: 'info',
      tags: tagsProps,
      elements: elementsTemplate,
      deleted: 'no'
    };

    setFieldsTemplate(templateSave);
    submitNewTemplate(templateSave);
  };

  const createNewAnnotation = async () => {
    const videoId = videoOps.getId(videoSelected);
    const { lat } = newCoords;
    const { lng } = newCoords;
    const coordsNewAnnotation = [lng, lat];
    const newTemplate = annotationsTemplate[annotationsTemplate.length - 1];

    const templateSaveAnnotationSchema = {
      _id: templateOps.getId(newTemplate),
      name: templateOps.getName(newTemplate),
      icon: templateOps.getIcon(newTemplate),
      tags: templateOps.getTags(newTemplate),
      elements: templateOps.getElements(newTemplate),
      createdAt: templateOps.getCreation(newTemplate),
      updatedAt: templateOps.getLastUpdate(newTemplate)
    };
    if (isValidateSchema === 'noValidate') {
      const annotationToSave = {
        geoJSON: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: coordsNewAnnotation
          },
          properties: {
            video: videoId,
            videoTime: timeNewAnnotation,
            videoPosition: sizePlayer,
            template: templateSaveAnnotationSchema
          }
        },
        origin: 'importJsonMaps',
        isTracking: false
      };
      submitNewAnnotation(annotationToSave);
    }
  };

  const handleTimePointVideo = event => {
    const { value } = event.target;
    const minutes = Number.parseInt(value.substr(0, 2), 10);
    const seconds = Number.parseInt(value.substr(3, 2), 10);
    if (value.substr(0, 2) === '00') {
      const time = seconds * 1e6;
      setTimeNewAnnotation(time);
    } else {
      const time = 60 * minutes + seconds;
      if (time > timeVideoDuration) {
        Bert.alert('Supera el tiempo máximo del video', 'danger');
      } else {
        setTimeNewAnnotation(time * 1e6);
      }
    }
  };

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      createNewAnnotation();
    } else if (isVideoLine && activeStep === 0) {
      const newTime = videoCalculate.calculateTimeVideoLine(
        videoSelected,
        proyectedPointTrackVideo,
        annotationsProp
      );
      setTimeNewAnnotation(newTime);
      setActiveStep(2);
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    if (isValidateSchema === 'validate' && isVideoLine) {
      setActiveStep(0);
    } else {
      setActiveStep(prevActiveStep => prevActiveStep - 1);
    }
  };

  const handleValidateSchema = async file => {
    try {
      const check = await methodPromise('annotations.validate', file, false);
      setValidateSchema(check);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const updateAnnotationFields = (elementItem, property, newValue) => {
    const newFieldsTemplate = cloneDeep(fieldsTemplate);
    const templateElementsArray = templateOps.getElements(fieldsTemplate);
    const newElementTemplate = map(templateElementsArray, element => {
      const newElement = element;
      if (
        isEqual(
          indexOf(templateElementsArray, element),
          indexOf(templateElementsArray, elementItem)
        )
      ) {
        newElement[property] = newValue;
      }
      return newElement;
    });
    newFieldsTemplate.elements = newElementTemplate;
    setFieldsTemplate(newFieldsTemplate);
  };

  const importFunction = async (parsedText, videoId, spatialSync, syncTimeGPS) => {
    const newImportObject = await importAnnotations({
      variableWithObjects: parsedText,
      videoId,
      spatialSync,
      syncTimeGPS
    });
    const { annotations = [] } = parsedText;
    const { countNoImported } = newImportObject;
    const timeFinalGPSstring = videoCalculate.getFinalGPSTimeVideo(videoSelected, 'format-date');
    const timeStartGPSstring = new Date(videoOps.getTimeGPS(videoSelected));
    Bert.alert(
      `La fecha de inicio del video es ${timeStartGPSstring.toUTCString()}. \nLa fecha de finalazación del video es ${timeFinalGPSstring}. \n`,
      'success'
    );
    Bert.alert(
      `Se han importado ${annotations.length - countNoImported} anotaciones de ${
        annotations.length
      }.`,
      'success'
    );
    handleCloseImport();
  };

  const handleImportJson = async () => {
    try {
      await methodPromise('annotationTemplates.hardDelete', newTemplateId);
      handleCloseImport();
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  React.useEffect(() => {
    setNewCoords(coordOnMap);
  }, [coordOnMap]);

  React.useEffect(() => {
    if (isValidateSchema === 'noValidate' && methodImport === 'json') {
      createTemplate();
      setNotesVideoEditor('import-anyJson');
    } else if (isValidateSchema === 'noValidate' && methodImport === 'annotations') {
      Bert.alert('El archivo no sigue el esquema de anotaciones', 'danger');
      handleCloseImport();
    }
  }, [isValidateSchema]);

  React.useEffect(() => {
    if (!isEmpty(fileJson)) {
      const { annotations = [] } = fileJson;
      if (isEmpty(annotations)) {
        handleValidateSchema(fileJson);
      } else {
        setValidateSchema('validate');
      }
    }
  }, [fileJson]);

  const timeString = videoCalculate.secondsToString(timeVideoDuration);

  if (loading) return <Loading />;
  return (
    <>
      <Box display="flex" height="100px" width="100%" alignItems="center" mr={5}>
        <Grid container direction="row" justifyContent="space-around" spacing={3}>
          <Grid item xs={10} sx={{ justifyContent: 'center', display: 'flex' }}>
            <Box sx={{ width: '90%' }}>
              <Stepper activeStep={activeStep}>
                {steps.map(label => {
                  const labelProps = {};
                  return (
                    <Step key={label}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {methodImport === 'annotations' && isValidateSchema === 'validate' && (
        <>
          {activeStep === 0 && (
            <Box display="flex">
              <Stack size="sm" direction="row" alignItems="center">
                <Button
                  size="sm"
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    importFunction(fileJson, videoOps.getId(videoSelected), true, false)
                  }
                >
                  Por coordenadas
                </Button>
                <Button
                  size="sm"
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    importFunction(fileJson, videoOps.getId(videoSelected), false, false)
                  }
                >
                  Por tiempo
                </Button>
                <Button
                  size="sm"
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    importFunction(fileJson, videoOps.getId(videoSelected), false, true)
                  }
                >
                  Por tiempo GPS
                </Button>
                <Button
                  size="sm"
                  variant="outlined"
                  color="error"
                  onClick={() => handleCloseImport()}
                >
                  Cancelar
                </Button>
              </Stack>
            </Box>
          )}
          {!isVideoLine && activeStep === 1 && (
            <>
              <Typography variant="h5" gutterBottom>
                Selecciona un tiempo para la anotacion
              </Typography>
              <br />
              <TextField type="time" defaultValue="00:00" onChange={handleTimePointVideo} />
              <Alert severity="info">{`El tiempo del video es ${timeString} segundos`}</Alert>
            </>
          )}
          {activeStep === 2 && (
            <>
              <Alert severity="info">{`Coordenadas: ${newCoords.lat}, ${newCoords.lng}`}</Alert>
              <Alert severity="info">{`Tiempo anotación: ${timeNewAnnotation * 1e-6} seg`}</Alert>
              <Box
                maxHeight={isValidateSchema === 'noValidate' ? '500px' : '100vh'}
                overflow="auto"
                width="100%"
              >
                <AnnotationTemplatePreview
                  annotationTemplate={fieldsTemplate}
                  previewMode="preview"
                  updateAnnotationFields={updateAnnotationFields}
                />
              </Box>
            </>
          )}
          {activeStep !== 0 && (
            <>
              <Box display="flex" height="100px" width="100%">
                <Stack direction="row" alignItems="center">
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                  >
                    Atrás
                  </Button>
                  <Button
                    disabled={isEmpty(newCoords)}
                    variant="outlined"
                    color={activeStep === steps.length - 1 ? 'success' : 'primary'}
                    onClick={handleNext}
                  >
                    {activeStep === steps.length - 1 ? 'Crear' : 'Siguiente'}
                  </Button>
                  <Button variant="outlined" color="error" onClick={() => handleCloseImport()}>
                    Cancelar
                  </Button>
                </Stack>
              </Box>
            </>
          )}
        </>
      )}
      {methodImport === 'json' && isValidateSchema === 'noValidate' && (
        <>
          {isEmpty(newCoords) && activeStep === 0 && (
            <Alert severity="info">Seleccione un punto en el mapa</Alert>
          )}
          {!isEmpty(newCoords) && activeStep === 0 && (
            <Alert severity="info">{`Coordenadas: ${newCoords.lat}, ${newCoords.lng}`}</Alert>
          )}
          {!isVideoLine && activeStep === 1 && (
            <>
              <Typography variant="h5" gutterBottom>
                Selecciona un tiempo para la anotacion
              </Typography>
              <br />
              <TextField type="time" defaultValue="00:00" onChange={handleTimePointVideo} />
              <Alert severity="info">{`El tiempo del video es ${timeString} segundos`}</Alert>
            </>
          )}
          {isVideoLine && activeStep === 1 && (
            <Alert severity="info">{`Coordenadas: ${newCoords.lat}, ${newCoords.lng} \n tiempo anotación: ${timeNewAnnotation}`}</Alert>
          )}
          {activeStep === 2 && (
            <>
              <Alert severity="info">{`Coordenadas: ${newCoords.lat}, ${newCoords.lng}`}</Alert>
              <Alert severity="info">{`Tiempo anotación: ${timeNewAnnotation * 1e-6} seg`}</Alert>
              <Box
                maxHeight={isValidateSchema === 'noValidate' ? '500px' : '100vh'}
                overflow="auto"
                width="100%"
              >
                <AnnotationTemplatePreview
                  annotationTemplate={fieldsTemplate}
                  previewMode="preview"
                  updateAnnotationFields={updateAnnotationFields}
                />
              </Box>
            </>
          )}
          <Box display="flex" height="100px" width="100%">
            <Stack direction="row" alignItems="center">
              <Button
                variant="outlined"
                color="primary"
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Atrás
              </Button>
              <Button
                disabled={isEmpty(newCoords)}
                variant="outlined"
                color={activeStep === steps.length - 1 ? 'success' : 'primary'}
                onClick={handleNext}
              >
                {activeStep === steps.length - 1 ? 'Crear' : 'Siguiente'}
              </Button>
              <Button variant="outlined" color="error" onClick={handleImportJson}>
                Cancelar
              </Button>
            </Stack>
          </Box>
        </>
      )}
    </>
  );
};

ImportAnnotationMaps.defaultProps = {
  annotationsTemplate: [],
  annotationsProp: [],
  isPublicMap: false,
  methodImport: 'annotations'
};

ImportAnnotationMaps.propTypes = {
  annotationsProp: PropTypes.array,
  annotationsTemplate: PropTypes.array,
  fileJson: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  handleCloseImport: PropTypes.func.isRequired,
  isPublicMap: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  timeVideoDuration: PropTypes.number.isRequired,
  sizePlayer: PropTypes.object.isRequired,
  videoSelected: PropTypes.object.isRequired,
  methodImport: PropTypes.string
};
export default withTracker(() => {
  const annotationTemplateSub = Meteor.isClient && Meteor.subscribe('annotationTemplates');
  const annotationsTemplate = AnnotationTemplates.find({}).fetch();
  const totalCountAnnotationsTemplate = AnnotationTemplates.find({}).count();

  return {
    annotationsTemplate,
    loading: !annotationTemplateSub.ready(),
    totalCountAnnotationsTemplate
  };
})(ImportAnnotationMaps);
